export default "__VITE_PUBLIC_ASSET__252bf773__"